import { render, staticRenderFns } from "./ExamineAppointment.vue?vue&type=template&id=0d9fefaf&style=height%3A%20100%25%3B"
import script from "./ExamineAppointment.vue?vue&type=script&lang=js"
export * from "./ExamineAppointment.vue?vue&type=script&lang=js"
import style0 from "./ExamineAppointment.vue?vue&type=style&index=0&id=0d9fefaf&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports